import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronRight, Plus, Landmark, ArrowRightLeft } from 'lucide-react'
import BDCoin from '../../Assets/icons/coin.png'
import { FaWallet } from 'react-icons/fa'
import { BiTransferAlt } from "react-icons/bi";
import { IoBagRemoveSharp } from "react-icons/io5";

const ICONS = {
  'plus': Plus,
  'send': BiTransferAlt,
  'landmark': Landmark,
  'shopping-cart': IoBagRemoveSharp ,
  'arrows-right-left': ArrowRightLeft,
  'wallet': FaWallet
}

function BalanceCard({ title, balance, currencySymbol = '$', isCoin = false, subValue, actions = [] }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className="bg-customGray rounded-xl p-4 w-full overflow-hidden">
      <div className="flex items-center justify-between gap-3">
        {/* Left Section */}
        <div className="min-w-0">
          <p className="text-sm mb-1 truncate">{title}</p>
          <div className="flex items-baseline gap-1 flex-wrap">
            {isCoin ? (
              <img src={BDCoin} className="w-4 h-4" alt="Coin" />
            ) : (
              <span className="text-sm">{currencySymbol}</span>
            )}
            <span className="text-3xl font-bold break-all">
              {isCoin ? balance.toLocaleString() : balance.toFixed(2)}
            </span>
          </div>
          {subValue && (
            <p className="text-xs mt-1 truncate">{subValue}</p>
          )}
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-4 shrink-0">
          <AnimatePresence>
            {expanded && (
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                className="flex items-center gap-4 flex-wrap max-w-[60vw] sm:max-w-none"
              >
                {actions.map((action, idx) => {
                  const Icon = ICONS[action.icon]
                  return (
                    <button
                      key={idx}
                      onClick={action.onClick}
                      className="flex flex-col items-center gap-1 hover:text-white transition-colors"
                    >
                      <div className="w-10 h-10 bg-[#3a3a3a] rounded-lg flex items-center justify-center">
                        <Icon className="w-5 h-5" />
                      </div>
                      <span className="text-xs whitespace-nowrap">{action.label}</span>
                    </button>
                  )
                })}
              </motion.div>
            )}
          </AnimatePresence>

          <button
            onClick={() => setExpanded(!expanded)}
            className="w-8 h-8 bg-[#3a3a3a] rounded-lg flex items-center justify-center hover:text-white transition-colors shrink-0"
          >
            <ChevronRight
              className={`w-5 h-5 transition-transform ${expanded ? 'rotate-180' : ''}`}
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default BalanceCard
